import { Card } from '@/shared/ui/card'
import { Skeleton } from '@/shared/ui/skeleton'

// Loading placeholder mirroring the Lugares club row (skeleton, not spinner).
export function ClubCardSkeleton() {
  return (
    <Card>
      <div className="p-4 flex items-center gap-3">
        <Skeleton className="h-12 w-12 rounded-[var(--radius)]" />
        <div className="flex-1 flex flex-col gap-2">
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-3 w-36" />
          <Skeleton className="h-3 w-24" />
        </div>
        <Skeleton className="h-4 w-10" />
      </div>
    </Card>
  )
}
